import React from "react";
import { useIntl } from "react-intl";
import PropTypes from 'prop-types';

import { reportsService } from "../../../services/reports-service";

import { DropdownSearchHelpInput } from "../../common/form-controls";

const getUsersDefault = (params, signal) => {
    return reportsService.getUsersUnifiedByLoginSearchHelp(params, signal);
};

const UsersInput = ({ ids, setIds, error, getUsers, label, disabledMultiple = false }) => {
    const intl = useIntl();
    const labelInner = intl.formatMessage({ id: "report-parameters.users-label" });

    return (
        <DropdownSearchHelpInput
            ids={ids}
            setIds={setIds}
            getData={getUsers}
            error={Boolean(error)}
            errorMessage={error?.message}
            label={label || labelInner}
            disableMultiple={disabledMultiple}

        />
    );
};

UsersInput.propTypes = {
    ids: PropTypes.arrayOf(PropTypes.string),
    setIds: PropTypes.func,
    error: PropTypes.object, 
    disabledMultiple: PropTypes.bool,
    getUsers: PropTypes.func,
    label: PropTypes.string
};

UsersInput.defaultProps = {
    getUsers: getUsersDefault
}

export default UsersInput;
